module.exports = __webpack_public_path__ + "img/custo-beneficio.d99cb9b9.png";